import React from "react";
import { Route, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/auth-context";

export default function PrivateRoute({ children }) {
  const { currentUser } = useAuth();
  const location = useLocation(); // Get the current location

  if (!currentUser) {
    // Save the current URL to localStorage before redirecting to login
    const currentUrl = window.location.href;
    localStorage.setItem("redirectAfterLogin", currentUrl);

    // Redirect to the login page
    return <Navigate to="/login" />;
  }

  // If the user is authenticated, render the children
  return children;
}
